import { render, staticRenderFns } from "./rfqIcon.vue?vue&type=template&id=13fd051a&scoped=true&"
import script from "./rfqIcon.vue?vue&type=script&lang=js&"
export * from "./rfqIcon.vue?vue&type=script&lang=js&"
import style0 from "./rfqIcon.vue?vue&type=style&index=0&id=13fd051a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fd051a",
  null
  
)

export default component.exports